import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IStatusListsPanelButtonProps } from './types';
import { STATUS_LISTS_TITLE } from '../../constants';
import {
    getAsidePanelActionsButtonTooltip
} from 'app/view/react_components/aside_panel/asidePanel/helpers/getAsidePanelActionsButtonTooltip';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function StatusListsPanelButton ({
    isEssentialFeature,
    isDisabled,
    tooltip,
    indicatorBoolean,
    onClick
}: IStatusListsPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.STATUS_MAPPING}
            indicatorBoolean={indicatorBoolean}
            isDisabled={isDisabled}
            isEssentialFeature={isEssentialFeature}
            title={STATUS_LISTS_TITLE}
            tooltip={tooltip && getAsidePanelActionsButtonTooltip({ value: tooltip })}
            onClick={() => {
                setSubTab(EBoardSetting.STATUS_MAPPING);
                onClick();
            }}
        />
    );
}
